export default __webpack_public_path__ + "static/media/notification_none.1fa85aaa.svg";